/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Template_Name_PlaceholderInputs */



/**
* | output |
* | --- |
* | "E.g. Peer coaching" |
*
* @param {Settings_Template_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_template_name_placeholder = /** @type {((inputs?: Settings_Template_Name_PlaceholderInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Template_Name_PlaceholderInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Bv. Intervisie")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ex. Intervision")
	return /** @type {LocalizedString} */ ("E.g. Peer coaching")
});